import React from 'react';

class ContratoDeAdhesion_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Contrato de Adhesión';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_CONTRATO_DE_ADHESION_2022_V1.pdf?alt=media&token=b86061ed-67f2-4054-aa5b-28ee32f824a6';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default ContratoDeAdhesion_pdf